// libs
import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LocaleString } from '@biw/intl';
//errors
import Errors from 'dux/errors/errors';
// shared components
import { Alert, DownloadIcon } from 'components/library';
//actionCreators
import { getActiveProgram } from 'dux/router/selectors';
import { downloadRulesPdf } from './rules-dux';
import HtmlContent from 'components/html-content';
// scss
import './rules.scss';

class Rules extends React.Component {

    static propTypes = {
        downloadRulesPdf: PropTypes.func,
        errors: PropTypes.string,
        rules: PropTypes.string
    }

    render() {
        const {
            downloadRulesPdf,
            errors,
            rules
        } = this.props;

        return (
            <div className="rules-content">
                { rules &&
                    <HtmlContent aria-label="Rules" className="rules-container" content={rules} />
                }

                <div className="export-rules">
                    <a className="export-rules-link" onClick={ downloadRulesPdf } data-sel="rules-export-button">
                        <span className="btn-export-rules branding-primary-button"> <DownloadIcon /> </span>
                        <br />
                        <span className="text-export-rules branding-secondary-text"><LocaleString code="rules.export" /></span>
                    </a>
                </div>
                {
                    errors && errors.error.length !== 0 && errors.error.map( ( error, index ) =>
                        <Alert type={ 'error' } key={ index }>
                            <p dangerouslySetInnerHTML={ { __html: error.responseMessage } } />
                        </Alert>
                    )
                }
            </div>
        );
    }
}

Rules = connect(
    state => {
        const activeProgram = getActiveProgram( state );
        return {
            rules: get( state, 'welcome.rules.value' ),
            ...activeProgram,
            error: Errors.getByType( state, Errors.ERROR_GOAL_SELECTION_SAVEGOAL ) || [],
        };
    },
    null,
    ( mapStateProps, { dispatch } ) => ( {
        ...mapStateProps,
        downloadRulesPdf: () => dispatch( downloadRulesPdf( mapStateProps.rules ) )
    } )
)( Rules );

export default Rules;
